function imgPreload (imgs) {
  if (imgs instanceof Array && imgs.length) {
    let div = document.createElement('div')
    imgs.forEach((imgUrl) => {
      let imgEle = document.createElement('img')
      imgEle.src = imgUrl
      div.appendChild(imgEle)
    })
    document.body.appendChild(div)
    setTimeout(() => {
      document.body.removeChild(div)
      div = null
    }, 0)
  }
}

export default imgPreload
